import {
  primaryColor,
  successColor,
  borderSubtleColor,
  textPrimaryColor,
  textMutedColor,
  boxShadow,
  fontSize,
} from '../material-dashboard-react';

const InquiriesStyle = () => ({
  filterInput: {
    border: `1px solid ${borderSubtleColor}`,
    borderRadius: 8,
    textAlign: 'center',
    width: '100%',
    height: 36,
    margin: '10px 0',
    backgroundColor: '#fff',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:focus': {
      borderColor: primaryColor,
      boxShadow: '0 0 0 3px rgba(0, 168, 188, 0.15)',
      outline: 'none',
    },
  },
  select: {
    padding: 1,
    fontSize: 14,
    '&:before': {
      borderColor: 'transparent',
      borderWidth: '0 !important',
    },
    '&:after': {
      borderColor: 'transparent',
      borderWidth: '0 !important',
    },
    '& *:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectItem: {
    fontSize: 14,
  },
  placeholder: {
    color: textMutedColor,
  },
  searchBtn: {
    float: 'right',
    marginTop: 30,
    marginRight: -5,
    borderRadius: 8,
    textTransform: 'none',
  },
  label: {
    display: 'inline-block',
    textAlign: 'center',
    color: textMutedColor,
    width: '16%',
  },
  labelsRow: {
    padding: '5px 10px',
  },
  dataRow: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    border: `1px solid ${borderSubtleColor}`,
    borderRadius: 10,
    height: 52,
    padding: '0 14px',
    marginBottom: 12,
    ...boxShadow,
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      borderColor: 'rgba(0, 168, 188, 0.35)',
      boxShadow: '0 4px 16px rgba(31, 42, 50, 0.08)',
    },
  },
  data: {
    display: 'inline-block',
    textAlign: 'center',
    color: textPrimaryColor,
    width: '16%',
  },
  l: {
    width: '20%',
  },
  stateTag: {
    display: 'inline-block',
    width: 105,
    borderRadius: 20,
    minHeight: 28,
    fontSize: 13,
    fontWeight: 500,
    color: '#fff',
    textAlign: 'center',
    lineHeight: '28px',
  },
  status2: {
    backgroundColor: '#1B9E6E',
  },
  status4: {
    backgroundColor: '#D64545',
  },
  status3: {
    backgroundColor: '#6B7780',
  },
  status5: {
    backgroundColor: '#E67E22',
  },
  status9: {
    backgroundColor: '#8E5BB8',
  },
  status11: {
    backgroundColor: '#6B3A8C',
  },
  status1: {
    backgroundColor: '#E67E22',
  },
  statusnull: {
    backgroundColor: '#E67E22',
  },
  status7: {
    backgroundColor: '#2F80B5',
  },
  status8: {
    backgroundColor: '#D64545',
  },
  dl_status1: {
    backgroundColor: '#E67E22',
  },
  dl_status2: {
    backgroundColor: '#E67E22',
  },
  dl_status3: {
    backgroundColor: '#6B7780',
  },
  dl_status4: {
    backgroundColor: '#1B9E6E',
  },
  dl_status5: {
    backgroundColor: '#D64545',
  },
  dl_status6: {
    backgroundColor: '#8E5BB8',
  },
  dl_statusnull: {
    backgroundColor: '#E67E22',
  },
  dl_status7: {
    backgroundColor: '#2F80B5',
  },
  dl_status8: {
    backgroundColor: '#D64545',
  },
  showBtn: {
    border: `1.5px solid ${primaryColor}`,
    borderRadius: 8,
    backgroundColor: '#fff',
    color: primaryColor,
    height: 40,
    textTransform: 'none',
    fontWeight: 500,
    '&:hover,&:focus': {
      backgroundColor: 'rgba(0, 168, 188, 0.08)',
      color: primaryColor,
    },
  },
  processBtn: {
    border: `1.5px solid ${successColor}`,
    borderRadius: 8,
    backgroundColor: '#fff',
    color: successColor,
    height: 40,
    textTransform: 'none',
    fontWeight: 500,
    '&:hover,&:focus': {
      backgroundColor: 'rgba(27, 158, 110, 0.08)',
      color: successColor,
    },
  },
  processBtnDisabled: {
    border: '1px solid #A8D5BE',
    borderRadius: 8,
    backgroundColor: '#fff',
    color: successColor,
    height: 40,
    textTransform: 'none',
    opacity: 0.65,
  },
  tab: {
    fontSize: fontSize.l,
    width: 180,
    height: 42,
    padding: 0,
    paddingLeft: 10,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    color: textMutedColor,
    transition: 'color 0.25s ease',
    textAlign: 'start',
    fontWeight: 400,
  },
  active: {
    color: textPrimaryColor,
    fontWeight: 500,
  },
  activeLine: {
    height: 3,
    backgroundColor: primaryColor,
    position: 'absolute',
    top: -1,
    borderRadius: 2,
    transition: '0.3s',
  },
  divider: {
    opacity: 1,
    borderColor: borderSubtleColor,
  },
});

export default InquiriesStyle;
